<template>
  <card-component title="¡Código de acceso generado!" icon="cellphone" :has-card-header-background="true" :has-button-slot="true">
    <b-loading :is-full-page="true" :active.sync="isLoading"/>
    <b-field>
        <template #label>
          Haz clic en el cuadrado derecho para copiar el <b>código de acceso</b>, y pégalo cuando te lo pidan.
        </template>
        <div class="field is-grouped">
        <div class="control is-expanded">
          <b-input
            v-model="code"
            readonly
          ></b-input>
        </div>
        <div class="control">
          <b-button type="is-orange" @click="copyCode">
            <b-icon icon="content-copy"></b-icon>
          </b-button>
        </div>
      </div>
    </b-field>
      <hr>
      <div class="control">
        <b-button  class="button is-orange" expanded @click="goToGoogle">
          Inicia sesión
        </b-button>
      </div>
  </card-component>
</template>

<script>
import { mapState } from 'vuex'
import CardComponent from '@/components/CardComponent'
import TokenRepository from '@/services/TokenRepository'
export default {
  name: 'CodeToken',
  components: { CardComponent },
  data () {
    return {
      isLoadingStartClaim: false,
      isLoadingChangePassword: false,
      isLoading: false,
      code: null
    }
  },
  mounted () {
    this.getCodeFromAPI()
  },
  computed: {
    ...mapState([
      'idUser'
    ])
  },
  created () {
    if (this.idUser === null) {
      this.$router.push('/start-claim')
    }
  },
  methods: {
    getCodeFromAPI () {
      this.isLoading = true
      TokenRepository.getAccessCode(this.idUser)
        .then((r) => {
          console.log('value' + r.data.access_code)
          console.log('value' + r.data.message)
          console.log('value' + r.data)
          this.code = r.data.access_code
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: 'Error al obtener el código',
            type: 'is-danger'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    copyCode () {
      navigator.clipboard.writeText(this.code).then(() => {
        this.$buefy.toast.open({
          message: 'Código copiado al portapapeles',
          type: 'is-orange'
        })
      }).catch(() => {
        this.$buefy.toast.open({
          message: 'No se pudo copiar el código',
          type: 'is-danger'
        })
      })
    },
    goToGoogle () {
      window.location.href = 'https://mifarma.workvivo.us/login'
    }
  }
}
</script>
<style>
.toast.is-orange {
  background-color: #ff9900 !important; /* Anaranjado */
  color: #fff !important;
}
.is-orange {
  background-color: #ff9900 !important; /* Anaranjado */
  color: #fff !important;
}
</style>
